import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { useState, useMemo, useEffect } from 'react';
import usePrevious from 'react-use/lib/usePrevious';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { useRadioGroup } from './RadioGroupProvider.js';
import { RadioContext } from './RadioProvider.js';

function noop() {
  //
}
const AccessibleRadio = React.forwardRef((_a, ref) => {
  var {
      value,
      isDisabled = false,
      onChange = noop,
      onFocus,
      onBlur,
      children
    } = _a,
    props = __rest(_a, ["value", "isDisabled", "onChange", "onFocus", "onBlur", "children"]);
  const {
    name,
    value: checkedValue,
    setValue
  } = useRadioGroup();
  const [isFocused, setFocused] = useState(false);
  const isChecked = useMemo(() => value === checkedValue, [checkedValue, value]);
  const isPrevChecked = usePrevious(isChecked);
  useEffect(() => {
    if (isChecked !== isPrevChecked && typeof isPrevChecked !== 'undefined') onChange(isChecked);
  }, [isChecked, isPrevChecked, onChange]);
  const context = useMemo(() => ({
    isChecked,
    check: isDisabled ? noop : () => setValue(value),
    uncheck: isDisabled ? noop : () => setValue(current => current === value ? undefined : current),
    isFocused,
    isDisabled
  }), [isChecked, isFocused, isDisabled, setValue, value]);
  return jsxs(RadioContext.Provider, {
    value: context,
    children: [jsx(VisuallyHidden, {
      children: jsx("input", Object.assign({
        ref: ref,
        disabled: isDisabled,
        type: "radio",
        onBlur: e => {
          setFocused(false);
          onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        },
        onChange: ({
          target: {
            checked
          }
        }) => {
          if (checked) setValue(value);
          onChange(checked);
        },
        onFocus: e => {
          setFocused(true);
          onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        }
      }, props, {
        checked: isChecked,
        name: name,
        value: value
      }))
    }), children]
  });
});

export { AccessibleRadio };
//# sourceMappingURL=AccessibleRadio.js.map
